import React from 'react';
import * as S from './ChooseBrandsModels.styled';
import ModelItem from './components/modelItem/ModelItem';
import BrandItem from './components/brandItem/BrandItem';

const ContentItem = ({ search, brandData, isOpened, toggleCheck, onOpenClick }) => (
  <S.Group>
    <S.OpenGroupWrapper>
      <BrandItem
        isOpened={isOpened}
        onOpenClick={onOpenClick}
        brandData={brandData}
        toggleCheck={toggleCheck}
        search={search}
      />
    </S.OpenGroupWrapper>
    <S.WrapForChooseRows>
      {isOpened &&
        brandData.models.map((model) => (
          <ModelItem
            search={search}
            key={model.counter}
            {...model}
            isChecked={model.isSelected}
            onChange={() => toggleCheck(model.counter)}
          />
        ))}
    </S.WrapForChooseRows>
  </S.Group>
);

export default ContentItem;
